import React, { useState } from 'react';
import { Link } from 'react-router-dom';

function PageHero({ title, sub }) {
  return (
    <div className="page-hero">
      <div className="page-hero-bg"/>
      <div className="container">
        <span className="section-tag">Patient Stories</span>
        <h1 className="page-hero-title">{title}</h1>
        <p className="page-hero-sub">{sub}</p>
      </div>
    </div>
  );
}

const reviews = [
  { name:'Patient Review', init:'PR', treatment:'Consultation Feedback', rating:5, text:'Patient review content should be updated with real feedback before publishing publicly.' },
  { name:'Implant Case', init:'IC', treatment:'Dental Implant Consultation', rating:5, text:'Use this section for verified implant-treatment feedback from actual patients of the clinic.', featured:true },
  { name:'Surgical Care', init:'SC', treatment:'Oral Surgery Consultation', rating:5, text:'Any testimonial added here should be fact-checked and approved before it goes live.' },
];

const stats = [
  { num:'BDS', label:'Dental Qualification' },
  { num:'MDS', label:'Oral Surgery Qualification' },
  { num:'1', label:'Lead Doctor Listed' },
  { num:'3', label:'Core Clinical Focus Areas' },
];

export default function Testimonials() {
  const [selected, setSelected] = useState(null);

  return (
    <>
      <PageHero title={<>Patient <em>Feedback</em></>} sub="This section should only carry verified patient reviews. Placeholder marketing testimonials have been removed." />

      {/* Stats */}
      <section className="section" style={{paddingBottom:0}}>
        <div className="container">
          <div className="review-stats reveal">
            {stats.map((s, i) => (
              <div key={i} className="review-stat">
                <span className="rs-num">{s.num}</span>
                <span className="rs-label">{s.label}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Reviews grid */}
      <section className="section">
        <div className="container">
          <div className="reviews-grid">
            {reviews.map((r, i) => (
              <div key={i} className={`review-card${r.featured ? ' featured' : ''} reveal`}
                style={{'--delay': `${(i % 3) * 0.1}s`}}
                onClick={() => setSelected(r)}>
                <div className="review-stars">{'★'.repeat(r.rating)}</div>
                <p className="review-text">"{r.text}"</p>
                <div className="review-author">
                  <div className="ra-avatar">{r.init}</div>
                  <div>
                    <div className="ra-name">{r.name}</div>
                    <div className="ra-treatment">{r.treatment}</div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Lightbox / expanded review */}
      {selected && (
        <div className="review-overlay" onClick={() => setSelected(null)}>
          <div className="review-modal" onClick={e => e.stopPropagation()}>
            <button className="modal-close" onClick={() => setSelected(null)}>✕</button>
            <div className="review-stars large">{'★'.repeat(selected.rating)}</div>
            <p className="modal-text">"{selected.text}"</p>
            <div className="review-author">
              <div className="ra-avatar large">{selected.init}</div>
              <div>
                <div className="ra-name">{selected.name}</div>
                <div className="ra-treatment">{selected.treatment}</div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* CTA */}
      <section className="section" style={{paddingTop:0}}>
        <div className="container">
          <div className="cta-inner reveal">
            <div className="cta-text">
              <h2>Need an Appointment?</h2>
              <p>Contact Dant Sanjeevani directly for consultation scheduling.</p>
            </div>
            <Link to="/contact" className="btn-primary btn-lg">Book Appointment →</Link>
          </div>
        </div>
      </section>
    </>
  );
}
